"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapControlsLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const L = __importStar(require("leaflet"));
const AddressSearchBar_1 = __importDefault(require("./components/AddressSearchBar/AddressSearchBar"));
const components_1 = require("./components");
function MapControlsLayout({ ...props }) {
    const scale = (0, react_1.useMemo)(() => {
        return L.control.scale({ imperial: false, updateWhenIdle: true });
    }, []);
    (0, react_1.useEffect)(() => {
        if (props.hideScale) {
            scale.remove();
        }
        else {
            scale.addTo(props.map.map);
        }
    }, [props.hideScale]);
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            display: "flex",
            flexDirection: "row"
        }, className: "w-100 h-100 p-2", children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    flex: 1
                }, children: !props.hideZoomControls && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(components_1.ZoomControls, { onPlusClick: () => {
                            props.map.map.zoomIn();
                        }, onMinusClick: () => {
                            props.map.map.zoomOut();
                        }, onFitClick: () => {
                            if (props.lauPolygon)
                                props.map.map.fitBounds(props.lauPolygon
                                    .getLeafletObject()
                                    .getBounds());
                        }, showFitButton: Boolean(props.lauPolygon) }) })) }), (0, jsx_runtime_1.jsxs)("div", { style: {
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    justifyContent: "space-between"
                }, children: [!props.hideSearchBar && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(AddressSearchBar_1.default, { map: props.map }) })), (0, jsx_runtime_1.jsx)("div", {}), !props.hideLegend && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(components_1.Legend, { title: props.legendTitle, render: props.legendRender }) }))] })] }));
}
exports.MapControlsLayout = MapControlsLayout;
